import React, { useState } from "react";
import { createRoot } from "react-dom/client";

const menuDom = document.querySelector("#menu-button");
const root = createRoot(menuDom);

const MenuButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleButtonClick = () => {
    setIsOpen(!isOpen);
    // document.querySelector("body").classList.toggle("fixedBody");
    document.querySelector("#nav__main").classList.toggle("is-active");
    document.querySelector("#header__site").classList.toggle("is-active");
  };
  return (
    <React.Fragment>
      <button className={isOpen ? "is-active" : ""} onClick={handleButtonClick}>
        <div className="hamburger__bars">
          <span className="bar"></span>
        </div>
      </button>
    </React.Fragment>
  );
};

root.render(<MenuButton />);

// Close nav when clicking outside the navigation or menu button
document.addEventListener("click", (event) => {
  const nav = document.querySelector("#nav__main");
  const header = document.querySelector("#header__site");
  const menuBtn = document.querySelector("#menu-button button");

  // If nav is not open, do nothing
  if (!nav.classList.contains("is-active")) return;

  // If the click was inside the nav or the menu button, ignore
  if (nav.contains(event.target) || menuBtn.contains(event.target)) return;

  // Otherwise, close the nav
  nav.classList.remove("is-active");
  header.classList.remove("is-active");

  // Reset the button state if needed
  menuBtn.classList.remove("is-active");
});

// Header Scroll Styling
let isScrolling = false;
const addThreshold = 110;
const removeThreshold = 90;

window.addEventListener("scroll", () => {
  const header = document.querySelector("#header__site");
  if (!isScrolling && window.scrollY > addThreshold) {
    document.body.classList.add("is-scrolling");
    isScrolling = true;
  } else if (isScrolling && window.scrollY < removeThreshold) {
    document.body.classList.remove("is-scrolling");
    isScrolling = false;
  }
});

const searchToggle = document.querySelector("#header-search-toggle");
if (searchToggle) {
  searchToggle.addEventListener("click", () => {
    document
      .querySelector("#header__actions")
      .classList.toggle("active-actions");
  });
}
